<template>
  <el-aside
    id="aside"
    width="250px"
  >
    <el-menu
      :default-active="routeIndex"
      class="el-menu-vertical-demo"
      :default-openeds="['finance']"
      router
    >
      <!-- 当无选中APP时，默认为所有游戏列表 -->
      <el-menu-item
        v-if="isAllApp"
        index="game"
        route="/appList"
      >
        <i class="iconfont icon-game" />
        <span slot="title">
          <span
            class="game-select-list-title"
            :title="currentApp.game_name"
          >{{ $t('allGame') || $t('selectGame') }}</span>
          <el-popover
            placement="right-start"
            trigger="hover"
            @show="visibleGameSelect = true"
            @hide="visibleGameSelect = false"
          >
            <i
              slot="reference"
              class="iconfont icon-menu toggle-icon"
            />

            <ApplicationSelect :visible="visibleGameSelect" />
          </el-popover>
        </span>
      </el-menu-item>
      <!-- 有选中APP -->
      <el-menu-item
        v-else
        index="game"
        :route="`/appDetail/${currentApp.app_id}`"
      >
        <i class="iconfont icon-game" />
        <span slot="title">
          <span
            class="game-select-selected"
            :title="currentApp.game_name"
          >{{ currentApp.game_name }}</span>
          <el-popover
            placement="right-start"
            trigger="hover"
            @show="visibleGameSelect = true"
            @hide="visibleGameSelect = false"
          >
            <i
              slot="reference"
              class="iconfont icon-menu toggle-icon"
            />

            <ApplicationSelect :visible="visibleGameSelect" />
          </el-popover>
        </span>
      </el-menu-item>

      <el-submenu index="finance">
        <template slot="title">
          <i class="iconfont icon-finance-solid" />
          <span>{{ $t('finance') }}</span>
        </template>
        <el-menu-item
          v-if="permissions('company_surplus_view')"
          index="finance-surplus"
          route="/surplus"
        >
          {{ $t('surplus') }}
        </el-menu-item>
        <el-menu-item
          index="finance-coupons"
          route="/couponsList"
        >
          {{ $t('coupons') }}
        </el-menu-item>
        <el-menu-item
          index="finance-feeBill"
          route="/feeBill"
        >
          {{ $t('feeBill') }}
        </el-menu-item>
        <el-menu-item
          v-if="permissions('company_gains_view')"
          index="finance-income"
          route="/incomeDashboard"
        >
          {{ $t('income') }}
        </el-menu-item>
        <el-menu-item
          index="finance-order"
          route="/orderList"
        >
          {{ $t('order') }}
        </el-menu-item>
        <el-menu-item
          index="finance-invoice"
          route="/invoiceList"
        >
          {{ $t('invoice') }}
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex';
import ApplicationSelect from './ApplicationSelect';

export default {
  components: {
    ApplicationSelect,
  },
  data() {
    return {
      visibleGameSelect: false,
    };
  },
  computed: {
    ...mapGetters(['currentApp']),
    routeIndex() {
      const { matched } = this.$route;

      if (matched.length > 0 && matched[0].meta.index) {
        return matched[0].meta.index.join('-');
      }

      return '';
    },
    isAllApp() {
      return this.currentApp.app_id === '';
    },
  },
};
</script>

<style>

</style>

<i18n src="./i18n.json"></i18n>
